"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const firestore_1 = require("firebase/firestore");
const getSplitPath_1 = tslib_1.__importDefault(require("../../utils/getSplitPath"));
const getSpecialtiesPath_1 = tslib_1.__importDefault(require("./getSpecialtiesPath"));
/**
 *
 * @param firestore
 * @param country 'AR' or 'MX'
 * @returns Especialidades que tiene appointments-mf
 */
async function getSpecialties(firestore, country) {
    const [path, document] = (0, getSplitPath_1.default)((0, getSpecialtiesPath_1.default)(country));
    let specialties;
    try {
        const docRef = (0, firestore_1.doc)(firestore, path, document);
        specialties = await (0, firestore_1.getDoc)(docRef);
    }
    catch (err) {
        throw new Error(`db error ${err}`);
    }
    if (specialties.exists()) {
        return specialties.data();
    }
    else {
        throw new Error("error: Medical History don't exist.");
    }
}
exports.default = getSpecialties;
